import _get from 'lodash/get';
import { StringColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';
import { IPermissionInfo } from 'models/settingsV2.model';

export const COL_NAMES = {
	permissionName: 'name',
	permissionDescription: 'description',
	permissionActionName: 'actionName'
};

export const columnConfigs = [
	StringColumn({
		title: 'Permission Name',
		mapDataToValue: (data: IPermissionInfo) => {
			return String(_get(data.permission_details, COL_NAMES.permissionName, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Permission Description',
		mapDataToValue: (data: IPermissionInfo) => {
			return String(_get(data.permission_details, COL_NAMES.permissionDescription, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Permission Action Name',
		maxWidth: 300,
		mapDataToValue: (data: IPermissionInfo) => {
			return String(_get(data.permission_details, COL_NAMES.permissionActionName, EMPTY_STRING));
		}
	})
];

export interface IUserPermissionsDetails {
	userPermissionsData: IPermissionInfo[];
}
